<template>
  <container subHeaderTitle="<b>개인정보처리방침</b>">
    <section class="privacy">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="py-0">
            <div v-if="isLoading" class="state">
              <v-progress-circular indeterminate color="primary" size="32" />
            </div>
            <div v-else-if="errorMessage" class="state">
              <p>{{ errorMessage }}</p>
            </div>
            <div v-else class="terms-content" v-html="termsContent"></div>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </container>
</template>

<script>
import Container from "@/pages/container/index.vue";
import { PRIVACY_POLICY_TERMS } from "@/const/index.js";

export default {
  name: "Privacy",
  components: { Container },
  data() {
    return {
      isLoading: true,
      termsContent: "",
      errorMessage: ""
    };
  },
  methods: {
    getPrivacyPolicy() {
      this.axios
        .post("/view/getTerms", PRIVACY_POLICY_TERMS)
        .then(res => {
          if (res.data.resultCode === "S0000") {
            this.termsContent = res.data.termsContent;
          } else {
            this.errorMessage = "개인정보처리방침을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.";
          }
        })
        .catch(() => {
          this.errorMessage = "개인정보처리방침을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.";
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  mounted() {
    this.getPrivacyPolicy();
  }
};
</script>

<style lang="scss" scoped>
.privacy {
  padding-bottom: 60px;

  .state {
    display: flex;
    justify-content: center;
    padding: 60px 18px;
    font-size: rem(13px);
  }

  .terms-content {
    padding: 0 18px;
    font-size: rem(12px);
    line-height: 1.7;
    word-break: keep-all;

    // 약관 본문은 DB 저장 HTML을 그대로 렌더하므로 scoped 속성이 붙지 않는다.
    ::v-deep {
      table {
        width: 100% !important;
        table-layout: fixed;
        border-collapse: collapse;
      }
      table, td, th {
        word-break: break-all !important;
      }
      img {
        max-width: 100%;
      }
    }
  }

  @include respond-to("small") {
    .terms-content {
      padding: 0 30px;
      font-size: rem(13px);
    }
  }

  @include respond-to("medium") {
    padding-bottom: 100px;
    .terms-content {
      padding: 0;
      font-size: rem(13px);
    }
  }
}
</style>
